import anime from 'animejs'
import throttle from 'lodash/throttle'

export default class Search {
  constructor(el) {
    this.el = el
    this.setVars()
    this.bindEvents()
  }

  setVars() {
    this.trigger = this.el
    this.panel = document.querySelector('[data-search-panel]')
    this.body = document.querySelector('body')
    this.close = this.panel.querySelector('[data-search-close]')
    this.screen = document.querySelector('[data-search-screen]')
    this.watchScroll = this.panel.querySelector('[data-watch-scroll]')
    this.screenOpacity = this.screen.dataset.endOpacity
    this.hits = this.panel.querySelector('#hits')
    this.buffer = 50
    this.masthead = document.querySelector('.primary-nav__top')
    this.loadMore = this.panel.querySelector('.ais-InfiniteHits-loadMore')
  }

  bindEvents() {
    this.trigger.addEventListener('click', this.handleLinkClick)
    this.close.addEventListener('click', this.handleLinkClose)
    this.watchScroll.addEventListener(
      'scroll',
      throttle(this.handleScrollHits, 100)
    )
    document.addEventListener('click', this.handleClickOff)
  }

  handleLinkClick = e => {
    e.preventDefault()
    if (this.trigger.classList.contains('s-active')) {
      this.animateOut()
      return false
    } else {
      this.trigger.classList.add('s-active')
      this.animateIn()
    }
  }

  handleLinkClose = e => {
    e.preventDefault()
    this.animateOut()
  }

  handleClickOff = e => {
    if (this.el.contains(e.target)) {
      return false
    }

    let isInside = this.panel.contains(e.target)
    if (!isInside) {
      this.animateOut()
    }
  }

  handleScrollHits = e => {
    if (
      this.getBottom(this.hits) - this.buffer <
      this.getBottom(this.watchScroll)
    ) {
      this.loadMore = this.panel.querySelector('.ais-InfiniteHits-loadMore')
      if (typeof this.loadMore != 'undefined') {
        this.loadMore.classList.add('s-auto-load')
        this.loadMore.click()
      }
      this.loadMore = this.panel.querySelector('.ais-InfiniteHits-loadMore')
      if (
        !this.loadMore.classList.contains('ais-InfiniteHits-loadMore--disabled')
      ) {
        this.panel.classList.add('s-more-results')
      } else {
        this.panel.classList.remove('s-more-results')
      }
    }
  }

  getMastheadHeight() {
    return this.masthead.getBoundingClientRect().bottom
  }

  getBottom(el) {
    return el.getBoundingClientRect().bottom
  }

  animateOut() {
    this.trigger.classList.remove('s-active')

    let timeline = anime.timeline({
      easing: 'easeInOutSine',
      duration: 180,
      complete: () => {
        this.panel.classList.add('hidden')
        this.screen.classList.add('hidden')
        this.body.classList.remove('s-search-open')
      }
    })

    timeline
      .add({
        targets: this.panel,
        opacity: [1, 0]
      })
      .add(
        {
          targets: this.screen,
          opacity: [this.screenOpacity, 0]
        },
        0
      )
  }

  animateIn() {
    this.body.classList.add('s-search-open')
    this.panel.classList.remove('hidden')
    this.screen.classList.remove('hidden')
    let offset = this.getMastheadHeight()
    let timeline = anime.timeline({
      easing: 'easeInOutSine',
      duration: 180,
      complete: () => {
        this.panel.querySelector('.ais-SearchBox-input').focus()
      }
    })

    timeline

      .add({
        targets: this.panel,
        translateY: [offset, offset],
        opacity: [0, 1]
      })
      .add(
        {
          targets: this.screen,
          opacity: [0, this.screenOpacity]
        },
        0
      )
  }
}
